import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Container, 
  Title, 
  Text, 
  Button, 
  Group, 
  Center,
  useMantineTheme,
  Box
} from '@mantine/core';
import { IconSearch, IconArrowLeft } from '@tabler/icons-react';
import { keyframes } from '@mantine/emotion';

const bounce = keyframes({
  '0%, 100%': { transform: 'translateY(0)' },
  '50%': { transform: 'translateY(-20px)' }
});

const ItemNotFound = ({backRoute="", ctaLabel="Return Home", description="We couldn't find the style you were looking for. It might have been removed or doesn't exist or is yet to be distributed.", ctaCallback}) => {
  const navigate = useNavigate();
  const theme = useMantineTheme();
  
  return (
    <Container size="md" py="xl" style={{height:'100%', display:'flex',flexDirection:'column', justifyContent:'center'}}>
      
      <Title align="center" mb="md">
        Style Not Found
      </Title>
      
      <Text c="dimmed" size="lg" align="center" mb="xl">
        {description}
      </Text>

      <Group justify="center">
        <Button 
          onClick={() => navigate(-1)} 
          leftIcon={<IconArrowLeft size={16} />}
          variant="outline"
        >
          Go Back
        </Button>
        <Button 
          onClick={() => {
            if(ctaCallback){
                ctaCallback()
            }else {
                navigate('/')
            }
        }} 
          leftIcon={<IconSearch size={16} />}
        >
          {ctaLabel}
        </Button>
      </Group>
    </Container>
  );
};

export default ItemNotFound;